module.exports = __webpack_public_path__ + "img/87.ff1bcb04.jpg";